import classnames from 'classnames';
import { object } from 'prop-types';

import User from 'shared/components/icon/User';
import { getText } from 'shared/utils/Text';

const BetItemType = ({ bet }) => {
  const betType = bet.getBetKey().getBetType();
  return (
    <div
      className={classnames(`bet-type-box bg-${betType}`, {
        'bet-type-box--trippel': IS_NO_SITE && betType === 'T',
      })}
    >
      {getText(`bet-type-short_${betType.toLowerCase()}`)}
      {bet.isShared() && (
        <div className={'bet-type-box__shared-icon-wrapper'}>
          <svg viewBox="0 0 100 100">
            <path
              stroke="none"
              fill="rgba(255, 255, 255, 0.5)"
              d="M0 100H100V0Z"
            />
          </svg>
          <User className={'bet-type-box__shared-icon'} />
        </div>
      )}
    </div>
  );
};

BetItemType.propTypes = {
  bet: object.isRequired, // SavedBet
};

export default BetItemType;
